import apiClient from '../clienteFebosAPI';

const RESOURCE = '/v2/documentos';

export const clDtesList = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}?${params}`, { operacionId: 'cl.dtes.listar' });
};

export const clDntCloudSearchList = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/buscar?${params}`, { operacionId: 'cl.dnts.listar' });
};

export const clGetDte = (paramsRequest) => {
  const params = apiClient.queryParams(paramsRequest);
  return apiClient.get(`/documentos/${paramsRequest.febosId}?${params}`, { operacionId: 'cl.obtener.dte' });
};

export const clListarDocumentosRecurrentes = ({
  filter,
  page,
  limit,
  order,
  formato
}) => apiClient.get(
  `/v2/buscar/factura-recurrente?${apiClient.queryParams({
    filtros: filter,
    pagina: page,
    itemsPorPagina: limit,
    orden: order,
    formato
  })}`,
  { operacionId: 'cl.dte.recurrente.listar' }
);

export const clObtenerDocumentoRecurrente = ({
  id,
  pdf
}) => apiClient.get(
  `/v2/documentos/recurrentes/${id}?${apiClient.queryParams({ pdf })}`,
  { operacionId: 'cl.dte.recurrente.obtener' }
);

export const clGuardarDocumentosRecurrentes = ({
  id,
  emisor,
  receptor,
  personalizados,
  detalle,
  referencias
}) => apiClient.post('/v2/documentos/recurrentes',
  {
    id,
    emisor,
    receptor,
    personalizados,
    detalle,
    referencias
  },
  { operacionId: 'cl.dte.recurrente.guardar' });
